<div class="avatar-container">
  <img
    *ngIf="imgSrc; else defaultProfilePicture"
    [src]="imgSrc"
    [alt]="altText"
    class="avatar-image"
  />
  <ng-template #defaultProfilePicture>
    <app-icon icon="fas fa-user"></app-icon>
  </ng-template>
</div>
